// Angular
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule, Injectable } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { GestureConfig } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';
// Angular in memory
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
// Perfect Scroll bar
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg';
// Env
import { environment } from '../environments/environment';
// Hammer JS
import 'hammerjs';
// NGX Permissions
import { NgxPermissionsModule } from 'ngx-permissions';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule, FullRouterStateSerializer } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// State
import { metaReducers, reducers } from './core/reducers';
// Copmponents
import { AppComponent } from './app.component';
// Modules
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { ThemeModule } from './views/theme/theme.module';
// Partials
import { PartialsModule } from './views/partials/partials.module';
// Layout Services
import {

	DataTableService,
	FakeApiService,
	KtDialogService,
	LayoutConfigService,
	LayoutRefService,
	MenuAsideService,
	MenuConfigService,
	MenuHorizontalService,
	PageConfigService,
	SplashScreenService,
	SubheaderService
} from './core/_base/layout';
// Auth
import { AuthModule } from './views/pages/auth/auth.module';
import { AuthService } from './core/auth';
// CRUD
import { HttpUtilsService, LayoutUtilsService, TypesUtilsService } from './core/_base/crud';
// Config
import { LayoutConfig } from './core/_config/layout.config';
// Highlight JS
//import { HIGHLIGHT_OPTIONS, HighlightLanguage } from 'ngx-highlightjs';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import * as typescript from 'highlight.js/lib/languages/typescript';
import * as scss from 'highlight.js/lib/languages/scss';
import * as xml from 'highlight.js/lib/languages/xml';
import * as json from 'highlight.js/lib/languages/json';
import { UserService } from './core/_services/user.service';
import { DatabaseService } from './core/_shared/database/database.service';
import { BasePathService } from './core/_services/BasePathService';
import { DialogsModule } from './core/_shared/dialogs/dialogs.module';
import { DefaultSearchDialogComponent } from './core/_shared/dialogs/default-search-dialog/default-search-dialog.component';
import { AppRegistryService } from './core/_services/app-registry.service';
import { PurchasesSearchDialogComponent } from './views/pages/operational/purchases/purchases-search-dialog/purchases-search-dialog.component';
import { OperationalModule } from './views/pages/operational/operational.module';
import { PurchasesSearchDialogModule } from './views/pages/operational/purchases/purchases-search-dialog/purchases-search-dialog.module';

// tslint:disable-next-line:class-name
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	wheelSpeed: 0.5,
	swipeEasing: true,
	minScrollbarLength: 40,
	maxScrollbarLength: 300,
};

export function initializeLayoutConfig(appConfig: LayoutConfigService) {
	// initialize app by loading default demo layout config
	return () => {
		if (appConfig.getConfig() === null) {
			appConfig.loadConfigs(new LayoutConfig().configs);
		}
	};
}

// export function hljsLanguages(): HighlightLanguage[] {
// 	return [
// 		{name: 'typescript', func: typescript},
// 		{name: 'scss', func: scss},
// 		{name: 'xml', func: xml},
// 		{name: 'json', func: json}
// 	];
// }


import { MatPaginatorIntl } from '@angular/material/paginator';

import { DeviceDetectorService } from 'ngx-device-detector';
import { ControllersService } from './core/_shared/controllers/controllers.service';
import { UrlService } from './core/_shared/utils/url.service';
import { StaticMemoryService } from './core/_shared/controllers/StaticMemory.service';
import { ConstantsService } from './core/_services/ConstantsService';
@Injectable()
export class MatPaginatorIntlCro extends MatPaginatorIntl {
  itemsPerPageLabel = 'Items por página';
  nextPageLabel     = 'Próxima';
  previousPageLabel = 'Anterior';
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        environment.isMockEnabled ? HttpClientInMemoryWebApiModule.forRoot(FakeApiService, {
            passThruUnknownUrl: true,
            dataEncapsulation: false
        }) : [],
        NgxPermissionsModule.forRoot(),
        PartialsModule,
        CoreModule,
        OverlayModule,
        //	StoreModule.forRoot(reducers, {metaReducers}),
        StoreModule.forRoot(reducers, {
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false,
            },
        }),
        EffectsModule.forRoot([]),
        StoreRouterConnectingModule.forRoot({ serializer: FullRouterStateSerializer, stateKey: 'router' }),
        StoreDevtoolsModule.instrument(),
        AuthModule.forRoot(),
        TranslateModule.forRoot(),
        MatProgressSpinnerModule,
        InlineSVGModule.forRoot(),
        ThemeModule,
        DialogsModule,
        PurchasesSearchDialogModule
    ],
    exports: [],
    providers: [
        AuthService,
        LayoutConfigService,
        DatabaseService,
        ControllersService,
        BasePathService,
        ConstantsService,
        LayoutRefService,
        MenuConfigService,
        PageConfigService,
        KtDialogService,
        DataTableService,
        AppRegistryService,
        UserService,
        UrlService,
        StaticMemoryService,
        SplashScreenService,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        // {
        // 	provide: HAMMER_GESTURE_CONFIG,
        // 	useClass: GestureConfig
        // },
        {
            // layout config initializer
            provide: APP_INITIALIZER,
            useFactory: initializeLayoutConfig,
            deps: [LayoutConfigService], multi: true
        },
        // {
        //     provide: HIGHLIGHT_OPTIONS,
        //     useValue: { languages: hljsLanguages }
        // },
        // template services
        SubheaderService,
        MenuHorizontalService,
        MenuAsideService,
        HttpUtilsService,
        TypesUtilsService,
        LayoutUtilsService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
